import { createApp } from 'vue' 
import App from './App.vue' 
import router from './router' 
import store from './store'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import Copy from "vue3-copy";
//import OpenLayersMap from "vue3-openlayers";
import { Geometries, Interactions, Layers, Map, Sources, Styles } from 'vue3-openlayers';

// import "vue3-openlayers/styles.css";

import maincomponents from '@/components'
const app = createApp(App); 
maincomponents.forEach(component => {
  app.component(component.name, component)
})

loadFonts()


app
  .use(router)
  .use(store)
  .use(vuetify)
  .use(Copy)
  //.use(OpenLayersMap /* options */)
  .use(Geometries /*, options */)
  .use(Interactions /*, options */)
  .use(Layers /*, options */)
  .use(Map /*, options */)
  .use(Sources /*, options */)
  .use(Styles /*, options */)


  //.use(fieldcalc)
  //.use(parser)

  .mount('#app') 
